import React from 'react';
import { Skeleton, List, ListItem } from '@mui/material';

function RoleListSkeleton({ skeletonSize = 4 }) {
  return (
    <List>
      {Array.from({ length: skeletonSize }).map((_id, idx) => (
        // eslint-disable-next-line react/no-array-index-key
        <ListItem key={idx}>
          <Skeleton
            variant="rounded"
            height={80}
            width="100%"
            x={theme => ({
              borderRadius: theme.shape.borderRadius * 2,
            })}
          />
        </ListItem>
      ))}
    </List>
  );
}

export default RoleListSkeleton;
